<template>
    <div v-if="showModal" id="stock_modal_set" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header">{{ partner.name }} 재설정</h3>
            </div>
            <div id="body" class="ui segment">
                <table class="ui very basic table">
                    <thead>
                        <tr>
                            <th class="collapsing">상품명</th>
                            <th class="collapsing" v-for="(center) in getCenters()" :key="center._id">{{ center.name }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(product) in newProducts" :key="product._id">
                            <td class="collapsing">{{ product.name }}</td>
                            <td class="collapsing" v-for="(center) in getCenters()" :key="center._id">
                                <div class='ui fluid small input'>
                                    <input type="number" v-model.number="product.centerStocks[center._id].count" @change="checkChanged()">
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div class="ui form">
                    <div class="inline field">
                        <input type="password" name="password" placeholder="비밀번호 입력" v-model="password">
                        <!-- <div class="ui teal button"  @click="download">단가 다운로드</div> -->
                        <div v-if="isChanged" class="ui orange button" @click="save">저장</div>
                        <div class="ui button" @click="close">닫기</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return { showModal: 0, isChanged: 0, partner: 0, oldProducts: 0, newProducts: 0, password: 0, onChange: 0, }
    },
    created: function() {
        this.showModal = false;
        this.isChanged = this.partner = this.oldProducts = this.newProducts = this.onChange = 0;
    },
    mounted: function() {
        this.$event.set("setStock", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("setStock");
    },
    methods: {
        open(_partnerId, onChange) {
            this.partner = this.findPartner(_partnerId);
            if (this.partner) {
                this.$event.call("openLoading");
                this.$api.getProductList(this.partner._id, (resData) => {
                    this.$event.call("closeLoading");
                    if (resData.error) {
                        alert(resData.error.message);
                    } else {
                        this.showModal = true;
                        this.isChanged = false;
                        this.password = "";
                        this.onChange = onChange;

                        for (const product of resData.products) {
                            for (const center of this.centers) {
                                if (!product.centerStocks[center._id]) product.centerStocks[center._id] = {};
                                if (!product.centerStocks[center._id].count) product.centerStocks[center._id].count = 0;
                            }
                        }

                        this.oldProducts = resData.products;
                        this.newProducts = JSON.parse(JSON.stringify(resData.products));
                    }
                });
            }
        },
        close() {
            this.showModal = false;
        },
        save()
        {
            if (this.password != this.stockPassword)
            {
                alert("비밀번호가 맞지 않습니다!");
                return;
            }

            if (this.checkChanged()) {
                this.$event.call("openLoading");
                this.$api.setStocks(this.partner._id, this.getChangedProducts(), (resData) => {
                    this.$event.call("closeLoading");
                    if (resData.error) {
                        alert(resData.error.message);
                    } else {
                        this.close();
                        if (this.onChange) this.onChange();
                    }
                });
            }
        },
        download()
        {
            if (this.password != this.stockPassword) {
                alert("비밀번호가 맞지 않습니다!");
                return;
            }
        },
        findPartner(_partnerId) {
            for (const partner of this.partners) {
                if (partner._id == _partnerId) {
                    return partner;
                }
            }
            return null;
        },
        checkChanged() {
            this.isChanged = false;
            for (var i=0; i<this.newProducts.length; i++) {
                for (const center of this.getCenters()) {
                    const newStock = this.newProducts[i].centerStocks[center._id];
                    const oldStock = this.oldProducts[i].centerStocks[center._id];
                    if (newStock.count != oldStock.count) {
                        this.isChanged = true;
                        return true;
                    }
                }
            }
            return false;
        },
        getChangedProducts() {
            const array = [];
            for (var i=0; i<this.newProducts.length; i++) {
                if (this.newProducts[i]._partner == this.partner._id) {
                    for (const center of this.getCenters()) {
                        const newStock = this.newProducts[i].centerStocks[center._id];
                        const oldStock = this.oldProducts[i].centerStocks[center._id];
                        if (newStock.count != oldStock.count) {
                            array.push({
                                _id: this.newProducts[i]._id,
                                centerStocks: this.newProducts[i].centerStocks,
                            });
                            break;
                        }
                    }
                }
            }
            return array;
        },
        getCenters()
        {
            const array = [];
            for (const center of this.centers)
            {
                if (!center.isTerminated)
                    array.push(center);
            }
            return array;
        },
    },
    computed: {
        ownerPassword: function() { return this.$store.getters.ownerPassword; },
        stockPassword: function() { return this.$store.getters.stockPassword; },
        centers: function() { return this.$store.getters.centers; },
        partners: function() { return this.$store.getters.partners; },
    },
}
</script>

<style>
#stock_modal_set {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#stock_modal_set .column {
    max-width: 1200px;
}

#stock_modal_set #header {
    padding: 20px 30px;
}

#stock_modal_set #body {
    padding: 50px;
}

#stock_modal_set #body .ui.form {
    padding: 10px;
}

#stock_modal_set #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#stock_modal_set #footer .ui.form {
    padding: 0;
}

#stock_modal_set .ui.form {
    padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/StockModal_Set.vue